import DisableUnchangedFields from './DisableUnchangedFields';
import EnableUnchangedFields from './EnableUnchangedFields';

// Save survey data before closing a question group to prevent data loss
export default function(parentContainer) {
  parentContainer
    .off('click.saveBeforeQuestionGroupNav', '.save-before-question-group-nav')
    .on('click.saveBeforeQuestionGroupNav', '.save-before-question-group-nav', function(e) {
      const link = $(this);
      const nativeLink = this;
      
      // Check both jQuery data and native dataset for skip flag
      if (link.data('skipAutoSaveNav') === true || nativeLink.dataset.skipAutoSaveNav === 'true') {
        link.removeData('skipAutoSaveNav');
        delete nativeLink.dataset.skipAutoSaveNav;
        return;
      }

      const rawNextShouldExpand = link.data('nextShouldExpand');
      const nextShouldExpand = rawNextShouldExpand === undefined ? '' : String(rawNextShouldExpand);
      const isClosingQuestionGroup = nextShouldExpand === 'false';
      const hasUnsavedChanges = $('.survey-card-body[data-val-changed=true]').length > 0;
      if (!isClosingQuestionGroup || !hasUnsavedChanges) {
        return;
      }

      e.preventDefault();

      let didNavigate = false;
      let saveAttempted = false;
      
      const cleanup = () => {
        document.removeEventListener('turbo:submit-end', onTurboSubmitEnd);
        $('#save_survey_form').off('ajax:complete.saveBeforeQuestionGroupNav');
        clearTimeout(fallbackTimeout);
      };
      
      const proceedAfterSave = () => {
        if (didNavigate) {
          return;
        }
        didNavigate = true;
        cleanup();
        EnableUnchangedFields();
        
        // Use native click for Turbo links, as jQuery trigger doesn't work well with Turbo
        const nativeLink = link.get(0);
        if (nativeLink) {
          nativeLink.dataset.skipAutoSaveNav = 'true';
          nativeLink.click();
        }
      };
      
      const handleSaveFailure = () => {
        cleanup();
        EnableUnchangedFields();
        // Show error to user - changes were not saved, don't navigate away
        const errorMessage = 'Failed to save changes. Please try again before navigating away.';
        // Check if there's an existing flash/toast system, otherwise use alert
        if (typeof window.showFlashMessage === 'function') {
          window.showFlashMessage('error', errorMessage);
        } else {
          alert(errorMessage);
        }
      };

      const onTurboSubmitEnd = (event) => {
        if (event.target && event.target.id === 'save_survey_form') {
          saveAttempted = true;
          if (event.detail && event.detail.success) {
            proceedAfterSave();
          } else {
            handleSaveFailure();
          }
        }
      };

      document.addEventListener('turbo:submit-end', onTurboSubmitEnd);
      $('#save_survey_form').one('ajax:complete.saveBeforeQuestionGroupNav', function(event, xhr) {
        saveAttempted = true;
        // Check for successful status (2xx)
        if (xhr && xhr.status >= 200 && xhr.status < 300) {
          proceedAfterSave();
        } else {
          handleSaveFailure();
        }
      });

      // Fallback timeout - only used if no response received (network issue)
      // Don't navigate, just re-enable fields and show error
      const fallbackTimeout = setTimeout(function() {
        if (!saveAttempted && !didNavigate) {
          cleanup();
          EnableUnchangedFields();
          alert('Save request timed out. Please check your connection and try again.');
        }
      }, 10000);

      // Prepare form fields (disable unchanged, enable changed) then save
      DisableUnchangedFields();
      const saveForm = document.getElementById('save_survey_form');
      if (saveForm && typeof saveForm.requestSubmit === 'function') {
        saveForm.requestSubmit();
      } else {
        $('#hiddenSaveSurvey').trigger('click');
      }
    });
}
